import styled from 'styled-components'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const Section = styled.section`
  padding: 96px 24px;
  position: relative;
  overflow: hidden;
`

const Glow = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 50% 100%, var(--color-accent-glow) 0%, transparent 60%);
  pointer-events: none;
`

const Inner = styled.div`
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
`

const Title = styled(motion.h2)`
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-bottom: 16px;
`

const Subtitle = styled(motion.p)`
  font-size: 1.1rem;
  color: var(--color-text-secondary);
  line-height: 1.7;
  margin-bottom: 36px;
`

const CTAButton = styled(Link)`
  display: inline-block;
  padding: 16px 40px;
  background: linear-gradient(135deg, var(--color-gradient-start), var(--color-gradient-end));
  color: white;
  border-radius: 10px;
  font-size: 1.05rem;
  font-weight: 600;
  transition: opacity 0.2s ease, transform 0.2s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    color: white;
  }
`

export default function CTASection({ title, subtitle, buttonText, buttonTo }) {
  return (
    <Section>
      <Glow />
      <Inner>
        <Title
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {title || "Let's take your company to the next level"}
        </Title>
        <Subtitle
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          {subtitle || "We'll be with you every step of the way."}
        </Subtitle>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <CTAButton to={buttonTo || '/contact'}>
            {buttonText || 'Book a Discovery Call'}
          </CTAButton>
        </motion.div>
      </Inner>
    </Section>
  )
}
